export default {
  // Custom themes
  // NOTE: All names are in lowercase
  qmkey: {
    logo: "/logos/qmkey.png",
    light: {
      primary: "#85a43c",
    },
  },
  qmfood: {
    logo: "/logos/qmfood.svg",
    light: {
      primary: "#f7a501",
    },
  },
  qmhealth: {
    logo: "/logos/qmsalud.svg",
    light: {
      primary: "#29A1C5",
    },
  },

  // Default theme
  logo: "/logos/qmkey.png",
  light: {
    primary: "#85a43c",
  },
  dark: {
    primary: "#85a43c",
  },

}

